import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TeacherIcon = ({
  color = "currentColor",
  strokeWidth = 1,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 20.4 20.876",
    fill: "none",
    stroke: color,
    strokeWidth: normalizeStrokeWidth(strokeWidth, 20.876),
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "m10.158 8.587a3.113 3.113 0 1 1 -2.785-3.409 3.113 3.113 0 0 1 2.785 3.409z"
    }), /*#__PURE__*/jsx("path", {
      d: "m1.5 20.376v-2.663a4.454 4.454 0 0 1 4.345-4.556h2.431a4.454 4.454 0 0 1 4.345 4.556v2.663"
    }), /*#__PURE__*/jsx("path", {
      d: "m17.313 13.269a2.57 2.57 0 0 0 2.587-2.554v-7.661a2.57 2.57 0 0 0 -2.587-2.554h-14.226a2.57 2.57 0 0 0 -2.586 2.554v4.271"
    })]
  });
};

export { PM2TeacherIcon };
//# sourceMappingURL=teacher.js.map
